export function getter(key) {
  if (!window.localStorage) return;
  try {
  } catch (err) {
  }
  return JSON.parse(localStorage.getItem(key));
}

export function setter(key, data) {
  if (!window.localStorage) return;
  localStorage.setItem(key, JSON.stringify(data));
}

// remove item function exported for the business agent usecase
export function removeItem(key) {
    if (!window.localStorage) return;
    localStorage.removeItem(key);
  }


// has item check function exported for the business agent usecase
export function hasItem(key) {
    if (!window.localStorage) return false;

    return localStorage.getItem(key) !== null;
  }
